import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../Styles/Navigation.css';

const Navigation = () => {
    return (
        <motion.nav
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="navigation"
        >
            <h1 className="logo">CYPHR</h1>
            <ul className="nav-links">
                <li><Link to="/">Home</Link></li>
                <li className="apps-menu">
                    <span>Apps ▾</span>
                    <ul className="apps-submenu">
                        <li><Link to="/void">Cyphr Void</Link></li>
                    </ul>
                </li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/privacy">Privacy</Link></li>
            </ul>
        </motion.nav>
    );
};

export default Navigation;
